export const GET_ROLES = 'GET_ROLES'
export const SET_ROLE_STATE = 'SET_ROLE_STATE'
export const SET_ROLES = 'SET_ROLES'
export const SET_FILTERS = 'SET_FILTERS'
export const PATCH_ROLE = 'PATCH_ROLE'
